/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IEnumerableOfIncidentRecordFileInfoDto } from './iEnumerableOfIncidentRecordFileInfoDto.schema';

export const IncidentRecordDto = zod.object({
  "id": zod.string().uuid().optional(),
  "incidentNumber": zod.string().optional(),
  "incidentTypeId": zod.number().optional(),
  "incidentTypeName": zod.string().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "dateReported": zod.coerce.date().optional(),
  "dateOfIncident": zod.coerce.date().optional(),
  "venueOfIncident": zod.string().optional(),
  "timeOfIncident": zod.coerce.date().optional(),
  "reportedMemberId": zod.string().uuid().optional(),
  "reporterMemberId": zod.string().uuid().optional(),
  "incidentDescription": zod.string().optional(),
  "physicalEvidence": zod.string().optional(),
  "witnessDetails": zod.string().optional(),
  "moneyInvolved": zod.string().optional(),
  "cycleAge": zod.number().optional(),
  "cancellationReason": zod.string().optional(),
  "decisionId": zod.number().optional(),
  "decisionName": zod.string().optional(),
  "disciplinaryActionId": zod.number().optional(),
  "disciplinaryActionName": zod.string().optional(),
  "remarks": zod.string().optional(),
  "reportedMemberDepartment": zod.string().optional(),
  "reportedMemberPosition": zod.string().optional(),
  "reportedMemberClient": zod.string().optional(),
  "reporterMemberDepartment": zod.string().optional(),
  "reporterMemberPosition": zod.string().optional(),
  "reporterMemberClient": zod.string().optional(),
  "createdBy": zod.string().optional(),
  "incidentRecordFiles": zod.lazy(() => IEnumerableOfIncidentRecordFileInfoDto).optional()
});

export type IncidentRecordDto = zod.input<typeof IncidentRecordDto>;
export type IncidentRecordDtoOutput = zod.output<typeof IncidentRecordDto>;
